const init = () => {
  const windowW = window.innerWidth;
  if (windowW > 960) {
    const gnavWrap = document.querySelector('.js-gnavWrap');
    const gnavItems = document.querySelectorAll('.js-gnavItem');
    const gnavSubMenuElms = document.querySelectorAll('.js-gnavSubMenu');

    gnavItems.forEach((elm, index) => {
      elm.addEventListener('mouseenter', () => {
        if(!document.documentElement.classList.contains('slideout-open')) {
          elm.classList.add('is-active');
          // gnavSubMenuElms[index]以外のis-activeを削除
          gnavSubMenuElms.forEach((subElm, subIndex) => {
            if (subIndex !== index) {
              subElm.classList.remove('is-active');
              gnavItems[subIndex].classList.remove('is-active');
            }
          });
          gnavSubMenuElms[index].classList.add('is-active');
        }
      });

      elm.addEventListener('mouseleave', (e) => {
        if (!document.documentElement.classList.contains('slideout-open')) {
          const relatedTarget = e.relatedTarget;
          if (!gnavSubMenuElms[index].contains(relatedTarget) && !gnavWrap.contains(relatedTarget)) {
            elm.classList.remove('is-active');
            gnavSubMenuElms[index].classList.remove('is-active');
          }
        }
      });

      gnavSubMenuElms[index].addEventListener('mouseleave', (e) => {
        if (!document.documentElement.classList.contains('slideout-open')) {
          const relatedTarget = e.relatedTarget;
          if (!elm.contains(relatedTarget) && !gnavWrap.contains(relatedTarget)) {
            elm.classList.remove('is-active');
            gnavSubMenuElms[index].classList.remove('is-active');
          }
        }
      });
    });
  }
}

const resizeW = () => {
  const windowW = window.innerWidth;
  if (windowW < 961) {
    const gnavItems = document.querySelectorAll('.js-gnavItem');
    const gnavSubMenuElms = document.querySelectorAll('.js-gnavSubMenu');

    gnavItems.forEach((elm, index) => {
      elm.classList.remove('is-active');
      gnavSubMenuElms[index].classList.remove('is-active');
    });
  }
}

export {
  init,
  resizeW
}